__turbopack_context__.v({
  "breadcrumbActiveLabel": "_0W3Voa_breadcrumbActiveLabel",
  "breadcrumbItem": "_0W3Voa_breadcrumbItem",
  "breadcrumbLabel": "_0W3Voa_breadcrumbLabel",
  "breadcrumbLink": "_0W3Voa_breadcrumbLink",
  "breadcrumbLinkText": "_0W3Voa_breadcrumbLinkText",
  "breadcrumbsContainer": "_0W3Voa_breadcrumbsContainer",
  "breadcrumbsList": "_0W3Voa_breadcrumbsList",
  "breadcrumbsScrollableContainer": "_0W3Voa_breadcrumbsScrollableContainer",
});
